import { render, staticRenderFns } from "./AbscessScarringPericarditisAnalysisTable.vue?vue&type=template&id=079c7735&scoped=true&"
import script from "./AbscessScarringPericarditisAnalysisTable.vue?vue&type=script&lang=ts&"
export * from "./AbscessScarringPericarditisAnalysisTable.vue?vue&type=script&lang=ts&"
import style0 from "./AbscessScarringPericarditisAnalysisTable.vue?vue&type=style&index=0&id=079c7735&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079c7735",
  null
  
)

export default component.exports